import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";

const API_URL = `${REACT_APP_API_URL}/api/auth/profile`;

export const fetchUserDetails = createAsyncThunk(
    'auth/fetchUserDetails', async (user, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_URL}`, {
                withCredentials: true,
                timeout: 7000,
            });

            return response.data.user;
        }
        catch (error) {
            if (
                error.code === "ECONNABORTED" ||
                error.message?.includes("timeout")
            ) {
                return rejectWithValue("Request timed out. Please try again.");
            }

            return rejectWithValue(
                error.response?.data?.message || "Unable to fetch user details"
            );
        }
    }
);

const userDetailsSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        loading: false,
        error: null,
        loaded: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
                state.loaded = true;

            })

            .addCase(fetchUserDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.loaded = true;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                state.user = null;
                state.loaded = true;
            });
    }
})
export const logoutUser = createAsyncThunk(
    'auth/logoutUser',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${REACT_APP_API_URL}/api/auth/logout`, {}, { withCredentials: true });
            return {};
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

export default userDetailsSlice.reducer;